import React, { useState, useEffect } from 'react'

import styled from 'styled-components'
import Box from '@components/Box'
import InputSlider from '@components/InputSlider'
import Radio from '@components/Radio/Radio'
import { STypographyDefault } from '@components/Typography'

import InputNumber from '@components/InputNumber/InputNumber'
import Tooltip from '@components/Tooltip'
import { pluralizeNumber } from '@/helpers/pluralizeNumber'
import { TGender, IControl } from '../types'
import { genders, retirementAges, maximumContribution, contributionSteps, minAge } from '../data'

const STooltip = styled(Tooltip)`
  margin-left: 9px;
`

export const SRadio = styled(Radio)`
  width: 100%;
  height: 100%;
`

const Control: React.FC<IControl> = (props) => {
  const { values, minimumContribution, estimatedYearsOfWork, onChange } = props
  const { gender, salary, income, age, exp, percentContribution } = values

  const [expValue, setExpValue] = useState<string | number>(exp)

  const retirementAge = retirementAges[gender]

  const genderHandler = (gender: TGender) => onChange({ ...values, gender })
  const ageHandler = (age: number) =>
    onChange((prevState) => {
      return { ...prevState, age }
    })
  const expHandler = (exp: number) => {
    if (exp === 0) {
      setExpValue('')

      return
    }

    setExpValue(exp)
    onChange({ ...values, exp })
  }
  const salaryHandler = (salary: number) => onChange({ ...values, salary })
  const incomeHandler = (income: number) => onChange({ ...values, income })
  const contributionHandler = (percentContribution: number) =>
    onChange((prevState) => ({ ...prevState, percentContribution }))

  useEffect(() => {
    expHandler(age === 18 ? 1 : age - minAge)
  }, [age])

  return (
    <>
      <STypographyDefault mb="20px" fontWeight="600">
        Ваш пол
      </STypographyDefault>
      <Box display={{ _: 'block', md: 'flex' }} mb="44px">
        <Box mr={{ _: '0', md: '24px' }} mb={{ _: '20px', md: '0' }} height="56px">
          <SRadio name="gender" values={genders} value={gender} onChange={(value) => genderHandler(value as TGender)} />
        </Box>
        <Box minWidth={{ xl: '227px' }} width="100%">
          <InputSlider min={18} max={retirementAge - 1} value={age} onChange={ageHandler} label="Ваш возраст" />
        </Box>
      </Box>
      <STypographyDefault mb="8px" fontWeight="600">
        Ваш стаж в атомной отрасли
      </STypographyDefault>
      <InputNumber min={0} max={retirementAges[gender] - minAge} value={expValue as number} onChange={expHandler} />
      <Box display="flex" alignItems="center" mt="10px">
        <STypographyDefault>
          {`${estimatedYearsOfWork} ${pluralizeNumber(estimatedYearsOfWork, ['год', 'года', 'лет'])} работы`}
        </STypographyDefault>
        <STooltip place="right" id="estimated">
          Предполагаемое количество лет работы
          <br />
          на предприятии от даты расчета (полных лет)
        </STooltip>
      </Box>
      <Box display="flex" justifyContent="space-between" mb="20px" mt="22px">
        <Box width="46%">
          <STypographyDefault mb="8px" fontWeight="600">
            Ваш оклад
          </STypographyDefault>
          <InputNumber min={0} value={salary} onChange={salaryHandler} />
        </Box>
        <Box width="46%">
          <STypographyDefault mb="8px" fontWeight="600">
            Ваша зарплата
          </STypographyDefault>
          <InputNumber min={0} value={income} onChange={incomeHandler} />
        </Box>
      </Box>
      <Box mb="24px">
        <InputSlider
          step={1}
          value={percentContribution}
          onChange={contributionHandler}
          label="Величина взноса (%)"
          disabled={minimumContribution === maximumContribution}
          {...(minimumContribution >= 1
            ? { min: minimumContribution, max: maximumContribution }
            : { min: 1, max: 7, steps: contributionSteps })}
        />
      </Box>
    </>
  )
}

export default Control
